'use strict';

(function () {
  angular
    .module('specsguardApp')
    .config(buildingTemplate);

  buildingTemplate.$inject = ['$stateProvider'];

  function buildingTemplate (stateProvider) {

    stateProvider
      .state('building_template', {
        url: '/building_template',
        templateUrl: 'app-legacy/components/sg-template-list/sg-template-list.html',
        controller: 'TemplateListCtrl',
        menu: {
          context: 'textual_template',
          title: '[Textual_templates]',
          subtitle: '[Gebouwen]',
          icon: 'location_city'
        },
        authenticate: true,
        params: {
          projectLevel: 2,
        },
        needRole: 7,
        resolve: {
          templates: ['BuildingTemplateAPI', function (BuildingTemplateAPI) {
            return BuildingTemplateAPI.query({}).$promise;
          }]
        }
      })
      .state('building_template_detail', {
        url: '/building_template/{templateId:string}',
        templateUrl: 'app-legacy/components/sg-template-detail/sg-template-detail.html',
        controller: 'sgTemplateDetail',
        controllerAs: '$sgTemplateDetail',
        menu: {
          context: 'textual_template',
          title: '[building_templates]',
          subtitle: '[TemplateName]',
          icon: 'location_city'
        },
        authenticate: true,
        needRole: 7,
        params: {
          projectLevel: 2,
          templateType: 'buildingTemplate'
        },
        resolve: {
          template: ['BuildingTemplateAPI', '$stateParams', function (BuildingTemplateAPI, $stateParams) {
            return BuildingTemplateAPI.get({ id: $stateParams.templateId }).$promise;
          }],
          constants: ['Constants', function (Constants) {
            return Constants.getConstants();
          }],
          elements: ['LibElement', function (LibElement) {
            return LibElement.getAll({ projectLevel: 2 }).$promise;
          }],
          modules: ['Module', function (Module) {
            return Module.get({}).$promise;
          }],
          areaTemplates: ['AreaTemplateAPI', function (AreaTemplateAPI) {
            return AreaTemplateAPI.getAll().$promise;
          }],
        }
      });
  }
})();
